import { OrderStatusHistoryResponse } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class OrderHistoryStatus<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Get an array with the order status history
	 *
	 * @tags Order History Status
	 * @name OrderStatusHistoryFindAll
	 * @summary Get the status history of an order
	 * @request GET:/store/{storeId}/hdm/order/{orderId}/statusHist
	 * @response `200` `OrderStatusHistoryResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	orderStatusHistoryFindAll = (
		storeId: string,
		orderId: string,
		query?: {
			/**
			 * Language identifier. If not specified, the "locale" parameter is used. If "locale" is not specified, then the store default language is used.
			 * @example "-1, -2, -3, -4, -5"
			 */
			langId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['orderStatusHistoryFindAll'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/order/${orderId}/statusHist`,
				params: _params,
				query: query,
				methodName: 'orderStatusHistoryFindAll',
			};
			logger.trace(traceData);
		}
		return this.http.request<OrderStatusHistoryResponse, void>({
			path: `/store/${storeId}/hdm/order/${orderId}/statusHist`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
